"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
var _default = exports.default = {
  name: 'HikeActivityReport',
  data() {
    return {
      hikeId: '',
      hikeTitle: '',
      loading: false,
      downloadLoading: false,
      reportData: null,
      reportHeader: null,
      column: null,
      header: null,
      autoWidth: 100,
      totalPercentOfAttendance: 0,
      totalPercentOfAttendancePerStage: [],
      avgOfCompletionRate: 0
    };
  },
  async created() {
    const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    this.hikeTitle = this.$route.query.title ? this.$route.query.title : '-';
    this.hikeId = id;
    this.getReport(id);
  },
  methods: {
    checkPermission: _permission.default,
    getReport(id) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeActivityReport)(token, id).then(response => {
        var resp = response.data;
        this.reportData = resp.reportdata;
        //this.reportHeader = resp.tableHeader

        if (this.reportData.length > 0) {
          this.header = this.reportData[0].activityStatus;
        }
        var attendancefigures = this.getPercentOfAttendance(resp.tableHeader, resp.reportdata);
        this.avgOfCompletionRate = this.getAverageCompleteRate(resp.reportdata);
        this.totalPercentOfAttendance = attendancefigures.hikePercentage;
        this.totalPercentOfAttendancePerStage = attendancefigures.stagePercentage;
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-activity-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/hike/index`);
    },
    handleDownload() {
      this.downloadLoading = true;
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        const xdata = this.buildExcelData();
        excel.export_json_to_excel({
          header: xdata.header,
          data: xdata.data,
          filename: 'Hike Activity Report'
        });

        //excel.export_table_to_excel('dataTable')

        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    buildExcelData() {
      var excelData = [];
      var excelHeader = [];
      // build first 4 header rows
      for (var i = 0; i < 4; i++) {
        var row = [];
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        if (i == 0) row.push('Stage');
        if (i == 1) row.push('Activity Type');
        if (i == 2) row.push('Activity Title');
        if (i == 3) row.push('Activity Steps');
        for (var j = 0; j < this.header.length; j++) {
          if (i == 0) row.push(this.header[j].stage + ' ');
          if (i == 1) row.push(this.header[j].activityType + ' ');
          if (i == 2) row.push(this.header[j].activityTitle + ' ');
          if (i == 3) row.push(this.header[j].activityStepValue + ' ');
        }
        if (i == 0) {
          excelHeader = row;
        } else {
          excelData.push(row);
        }
      }

      // build data row
      for (var x = -1; x < this.reportData.length; x++) {
        var row = [];
        // data row header
        if (x == -1) {
          row.push("Given name");
          row.push("Surname");
          row.push("Email");
          row.push("Trail Selection");
          row.push("% of selected stage complete");
          row.push("Total Steps");
          row.push("-");
          for (var z = 0; z < this.header.length; z++) {
            row.push('-');
          }
        } else {
          row.push(this.reportData[x].givenName);
          row.push(this.reportData[x].familyName);
          row.push(this.reportData[x].email);
          row.push(this.reportData[x].trail);
          row.push(this.reportData[x].completionPercentage);
          row.push(this.reportData[x].userTotalSteps);
          row.push("-");
          for (var z = 0; z < this.header.length; z++) {
            var isDone = this.reportData[x].activityStatus[z].isDone;
            row.push(isDone);
          }
        }
        excelData.push(row);
      }
      return {
        data: excelData,
        header: excelHeader
      };
    },
    getPercentOfAttendance(header, data) {
      var percentOfAttendanceOfHike = 0;
      var percentOfAttendanceOfStages = [];
      var checkinstageId = [];
      var noOfParticipant = data.length;
      var totalCheckinStage = 0;
      var totalUserCheckin = 0;
      var totalCompletionRate = 0;
      for (var i = 0; i < header.length; i++) {
        if (header[i].stageType === 'checkin') {
          checkinstageId.push(header[i].stageId);
          totalCheckinStage += 1;
        }
      }
      for (var h = 0; h < checkinstageId.length; h++) {
        var totalUserCheckinStage = 0;
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].activityStatus.length; j++) {
            if (data[i].activityStatus[j].stageType == 'checkin' && data[i].activityStatus[j].isDone == 'YES' && data[i].activityStatus[j].stageId == checkinstageId[h]) {
              totalUserCheckinStage += 1;
            }
          }
        }
        totalUserCheckin += totalUserCheckinStage;
        percentOfAttendanceOfStages.push((totalUserCheckinStage / noOfParticipant * 100).toFixed(2));
      }
      percentOfAttendanceOfHike = (totalUserCheckin / (totalCheckinStage * noOfParticipant) * 100).toFixed(2);
      return {
        hikePercentage: percentOfAttendanceOfHike,
        stagePercentage: percentOfAttendanceOfStages
      };
    },
    getAverageCompleteRate(data) {
      var totalCompletionRate = 0;
      var noOfParticipant = data.length;
      for (var i = 0; i < data.length; i++) {
        var rate = data[i].completionPercentage.replace('%', '');
        totalCompletionRate += parseInt(rate);
      }
      return (totalCompletionRate / noOfParticipant).toFixed(2);
    }
  }
};